// Given a value, returns true if null or undefiend

export default function isBlank(value) {
  return value === null || value === void 0
}



// WEBPACK FOOTER //
// ./src/isBlank.js